import React from "react";

const TicketCards = () => {
  return (
    <>
      <div className="support-card-header">
        <h3>Trámites en los que te podemos apoyar</h3>
      </div>
      <div className="support-card-body">
        <ul>
          <li>
            <strong>Peticiones:</strong> Estamos contigo en cada paso. Aquí
            puedes solicitar información o hacer consultas relacionadas con
            nuestros servicios.
          </li>
          <li>
            <strong>Quejas:</strong> Tus opiniones nos impulsan a mejorar. Usa
            este canal para contarnos si algo en nuestra atención o servicio no
            fue como esperabas.
          </li>
          <li>
            <strong>Reclamos:</strong> Queremos seguir creciendo contigo. Si no
            estás de acuerdo con algún aspecto del servicio, puedes contárnoslo
            por este medio para revisar nuestros procesos y garantizar una
            solución.
          </li>
          <li>
            <strong>Sugerencias:</strong> ¡Queremos que tu próxima experiencia
            sea aún mejor! Comparte aquí tus ideas o propuestas para ayudarnos a
            mejorar.
          </li>
          <li>
            <strong>Felicitaciones:</strong> Nuestro equipo se esfuerza por
            brindarte lo mejor cada día. Si has vivido momentos inolvidables con
            nosotros, cuéntanoslos aquí.
          </li>
        </ul>
      </div>
      <div>
        <div className="follow-up-card-header">
          <h3>Procedimiento de seguimiento y respuesta de las PQRSF</h3>
        </div>
        <div className="follow-up-card-body">
          <p>
            Cuando presentes una PQRSF (Petición, Queja, Reclamo, Sugerencia o
            Felicitación), te daremos respuesta en un plazo máximo de 15 días
            hábiles desde la fecha de radicación, conforme a lo establecido en
            la Ley 1480 de 2011 (artículo 58, numeral 5, literal C). La
            respuesta será enviada al correo electrónico que registraste al
            adquirir el servicio.
          </p>

          <ul>
            <li>
              Las peticiones de información o de documentos se resolverán en un
              plazo de 10 días hábiles desde su recepción.
            </li>
            <li>
              Si necesitamos información o documentos adicionales para continuar
              con tu solicitud, te informaremos los motivos. Tendrás un mes a
              partir del aviso para enviarnos lo solicitado. Si no recibimos
              respuesta dentro del plazo indicado, aplicaremos lo establecido en
              la Ley 1755 de 2015 y entenderemos que desistes de forma tácita,
              por lo que archivaremos la solicitud.
            </li>
            <li>
              En cuanto a los requerimientos relacionados con el tratamiento de
              datos personales, y en cumplimiento de la Ley 1581 de 2012:
            </li>
            <li>
              Las consultas se responderán en un plazo máximo de 10 días
              hábiles, prorrogables por 5 días hábiles adicionales si es
              necesario.
            </li>
            <li>
              Las quejas y reclamos se atenderán en un máximo de 15 días
              hábiles, prorrogables por 8 días hábiles
              adicionales si se requiere.
            </li>
          </ul>
        </div>
      </div>
    </>
  );
};

export default TicketCards;
